import apiClient from './apiClient';

export const askQuestion = async (docID, question) => {
    return apiClient
        .get(`/documents/qa?doc_id=${docID}&question=${question}`)
        .then((res) => res.data)
        .catch((err) => Promise.reject({ ...err }));
};
